import React from 'react';
import styled, { css } from 'styled-components';
import { cinnabar300 } from '../../theme/colors';

const FilterIconStyle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  cursor: pointer;
  color: #64748b;
  position: relative;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;

  svg {
    font-size: 20px;
    transition: color 0.2s ease;
  }

  &:hover {
    border-color: #6366f1;
    color: #6366f1;
    background: #fafafe;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
  }

  /* Active filter indicator dot */
  ${props => props.applied &&
    css`
      border-color: #64748b;
      color: #64748b;

      &:after {
        content: '';
        position: absolute;
        top: 6px;
        right: 6px;
        width: 7px;
        height: 7px;
        background-color: #64748b;
        border-radius: 50%;
        border: 1.5px solid #ffffff;
      }
    `
  }

  /* Tablet / Mobile — slightly smaller */
  @media (max-width: 767px) {
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }
`

const IconWithRedBubble = ({ children, title = "Filter (Alt + F)", onKeyDown, onClick, ...rest }) => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (onClick) onClick(e);
      }
      if (onKeyDown) onKeyDown(e);
    };

    return (
      <FilterIconStyle
        data-shortcut="filter"
        title={title}
        role="button"
        tabIndex={0}
        aria-label={rest['aria-label'] || "Toggle filters (Alt + F)"}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        {...rest}
      >
        {children}
      </FilterIconStyle>
    );
};

export default IconWithRedBubble;